const API_ROUTES = {
  GET_TOKENS: "/User/auth/callback",
  REFRESH_TOKENS: "/User/auth/refresh",
  GET_PRESENTATION_LIST: "",
  SUBMIT_QUESTIONNAIRE: "",
  USER_LOG_ERROR: "/User/log/error",
};

export default API_ROUTES;
